export default __webpack_public_path__ + "static/media/new-checkbox.6a222196.svg";